export default {"src":"/_next/static/media/majesticons_briefcase-line.5366988c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};